"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const recompose_1 = require("recompose");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const questionnaire_1 = __importDefault(require("@zedoc/questionnaire"));
const selectors_1 = require("@zedoc/selectors");
const QuestionnaireContext_1 = __importStar(require("./QuestionnaireContext"));
const actions_1 = require("./actions");
const selectors_2 = require("./selectors");
const useSelectorsHub_1 = __importDefault(require("./useSelectorsHub"));
const Questionnaire = react_1.default.forwardRef(({ name, questionnaire, properties, variables, sessionId, answersSheetId, debounceEdit, disabled, children, onSubmit, onSubmitError, readOnly, initialValues, keepStateOnUnmount, allowReinitialize, }, forwardRef) => {
    const context = (0, useSelectorsHub_1.default)({
        name,
        questionnaire,
        properties,
        variables,
        sessionId,
        answersSheetId,
        debounceEdit,
        disabled,
    });
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        if (allowReinitialize && !readOnly && initialValues) {
            dispatch((0, actions_1.initializeQuestionnaire)(name, initialValues));
        }
    }, [name, dispatch, readOnly, allowReinitialize, initialValues]);
    (0, react_1.useEffect)(() => {
        if (allowReinitialize) {
            return () => { };
        }
        if (!readOnly && initialValues) {
            // NOTE: initialValues is intentionally not included
            //       in dependencies array because we don't want
            //       to re-run this hook when initialValues change.
            dispatch((0, actions_1.initializeQuestionnaire)(name, initialValues));
        }
        return () => {
            if (!keepStateOnUnmount) {
                dispatch((0, actions_1.clearQuestionnaire)(name));
            }
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [name, dispatch, readOnly, allowReinitialize]);
    (0, react_1.useImperativeHandle)(forwardRef, () => ({
        setErrors: (errors) => {
            return dispatch(context.setErrors(errors));
        },
        submit: ({ dryRun } = {}) => {
            return dispatch(context.validate(dryRun))
                .then((value) => {
                if (onSubmit) {
                    onSubmit(value);
                }
                return value;
            })
                .catch((err) => {
                if (onSubmitError) {
                    onSubmitError(err);
                }
                throw err;
            });
        },
    }), [context, dispatch, onSubmit, onSubmitError]);
    return react_1.default.createElement(QuestionnaireContext_1.default.Provider, { value: context }, children);
});
Questionnaire.propTypes = {
    name: prop_types_1.default.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    initialValues: prop_types_1.default.objectOf(prop_types_1.default.any),
    keepStateOnUnmount: prop_types_1.default.bool,
    // eslint-disable-next-line react/forbid-prop-types
    variables: prop_types_1.default.objectOf(prop_types_1.default.any),
    // eslint-disable-next-line react/forbid-prop-types
    properties: prop_types_1.default.objectOf(prop_types_1.default.any),
    allowReinitialize: prop_types_1.default.bool,
    questionnaire: prop_types_1.default.instanceOf(questionnaire_1.default).isRequired,
    children: prop_types_1.default.node.isRequired,
    debounceEdit: prop_types_1.default.number,
    sessionId: prop_types_1.default.string,
    answersSheetId: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    onSubmit: prop_types_1.default.func,
    onSubmitError: prop_types_1.default.func,
};
Questionnaire.defaultProps = {
    initialValues: null,
    keepStateOnUnmount: false,
    variables: null,
    properties: null,
    allowReinitialize: false,
    sessionId: null,
    answersSheetId: null,
    debounceEdit: 0,
    disabled: false,
    readOnly: false,
    onSubmit: null,
    onSubmitError: null,
};
Questionnaire.connect = (createMapStateToProps) => {
    return (0, recompose_1.compose)((0, QuestionnaireContext_1.withContext)(), (0, react_redux_1.connect)(() => createMapStateToProps((0, selectors_2.liftContextSelectors)((0, selectors_1.property)('context')))));
};
exports.default = Questionnaire;
//# sourceMappingURL=Questionnaire.js.map